/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {LegalEntityRegionDTO} from './LegalEntityRegionDTO';
import {LegalEntitySubsidiaryDTO} from './LegalEntitySubsidiaryDTO';

/**
 * The LegalEntityCompanyDTO model module.
 * @module model/LegalEntityCompanyDTO
 * @version v0
 */
export class LegalEntityCompanyDTO {
  /**
   * Constructs a new <code>LegalEntityCompanyDTO</code>.
   * @alias module:model/LegalEntityCompanyDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntityCompanyDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntityCompanyDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntityCompanyDTO} The populated <code>LegalEntityCompanyDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntityCompanyDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
      if (data.hasOwnProperty('legalEntityRegion'))
        obj.legalEntityRegion = LegalEntityRegionDTO.constructFromObject(data['legalEntityRegion']);
      if (data.hasOwnProperty('legalEntitySubsidiary'))
        obj.legalEntitySubsidiary = LegalEntitySubsidiaryDTO.constructFromObject(data['legalEntitySubsidiary']);
      if (data.hasOwnProperty('authorityCode'))
        obj.authorityCode = ApiClient.convertToType(data['authorityCode'], 'String');
      if (data.hasOwnProperty('deletable'))
        obj.deletable = ApiClient.convertToType(data['deletable'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntityCompanyDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
LegalEntityCompanyDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
LegalEntityCompanyDTO.prototype.active = undefined;

/**
 * @member {module:model/LegalEntityRegionDTO} legalEntityRegion
 */
LegalEntityCompanyDTO.prototype.legalEntityRegion = undefined;

/**
 * @member {module:model/LegalEntitySubsidiaryDTO} legalEntitySubsidiary
 */
LegalEntityCompanyDTO.prototype.legalEntitySubsidiary = undefined;

/**
 * @member {String} authorityCode
 */
LegalEntityCompanyDTO.prototype.authorityCode = undefined;

/**
 * @member {Boolean} deletable
 */
LegalEntityCompanyDTO.prototype.deletable = undefined;

